<template>
  <div>
    <p
      class="font-bold text-typo-primary mb-1"
      :class="{
        '!text-error': newTender.v$.value.city.$error,
      }"
    >
      {{ $t("newTender.formData.city") }}
    </p>
    <p
      v-if="showEducation"
      class="font-semibold text-sm mb-1 opacity-80 text-typo-primary"
      :class="{
        '!text-error': newTender.v$.value.city.$error,
      }"
    >
      {{ $t("newTender.education.city") }}
    </p>
    <AutocompleteCity
      ref="input"
      v-model="newTender.city.value"
      :placeholder="$t('searchBox.cityPlaceholder')"
      @select="newTender.saveToStorage"
    />
  </div>
</template>

<script>
import AutocompleteCity from "~/components/_refactored/autocomplete/AutocompleteCity.vue";
import { useNewTender } from "~/composables/tender/useNewTender";

export default {
  components: {
    AutocompleteCity,
  },
  props: {
    showEducation: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const newTender = useNewTender();

    return {
      newTender,
    };
  },
  methods: {
    focus() {
      this.$refs.input.focusInput();
    },
  },
};
</script>
